module.exports = __webpack_public_path__ + "static/img/experience-of-british-bangladeshis-and-pakistanis-in-city-law.97bf156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/experience-of-british-bangladeshis-and-pakistanis-in-city-law.png
// module id = 4WDT
// module chunks = 0